"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultSupplementalListStyles = exports.DefaultMenuParentStyles = exports.DefaultLogoStyles = exports.DefaultLogoImageStyles = exports.DefaultInnerContainerStyles = exports.DefaultContainerStyles = exports.DefaultCategoryStyles = exports.DefaultAppBarStyles = void 0;
const DefaultAppBarStyles = theme => {
    return {
      background: "white",
      zIndex: "990"
    };
  },
  DefaultCategoryStyles = () => {
    return {
      alignItems: "stretch",
      backgroundColor: "#004569",
      color: "white",
      fontSize: "1.3rem",
      justifyContent: "flex-start",
      lineHeight: "1",
      "> *": {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0 0 0 20rem"
      }
    };
  },
  DefaultContainerStyles = theme => theme.mixins.container.outer,
  DefaultInnerContainerStyles = theme => theme.mixins.container.inner,
  DefaultMenuParentStyles = function () {
    let justifyContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "flex-start";
    return {
      alignItems: "center",
      display: "flex",
      justifyContent: justifyContent,
      padding: "1.8rem 0 1.9rem"
    };
  },
  DefaultLogoStyles = () => {
    return {
      boxShadow: "none",
      flex: "0 0 auto",
      margin: "0 5rem 0 0",
      padding: "0"
    };
  },
  DefaultLogoImageStyles = () => {
    return {};
  },
  DefaultSupplementalListStyles = () => {
    return {
      "ul": {
        display: "flex",
        fontSize: "1.3rem",
        justifyContent: "flex-end"
      },
      "li": {
        alignItems: "center",
        display: "inline-flex",
        listStyle: "none",
        margin: "0 0 0 4rem",
        padding: "0",
        textAlign: "center",
        "&:first-of-type": {
          marginLeft: "0"
        }
      },
      "a": {
        color: "inherit",
        textDecoration: "none",
        "&:hover,&:active,&:focus-visible": {
          color: "inherit",
          textDecoration: "underline"
        },
        "&:focus-visible": {
          color: "inherit",
          outlineColor: "white",
          textDecoration: "underline"
        }
      }
    };
  };
exports.DefaultSupplementalListStyles = DefaultSupplementalListStyles;
exports.DefaultLogoImageStyles = DefaultLogoImageStyles;
exports.DefaultLogoStyles = DefaultLogoStyles;
exports.DefaultMenuParentStyles = DefaultMenuParentStyles;
exports.DefaultInnerContainerStyles = DefaultInnerContainerStyles;
exports.DefaultContainerStyles = DefaultContainerStyles;
exports.DefaultCategoryStyles = DefaultCategoryStyles;
exports.DefaultAppBarStyles = DefaultAppBarStyles;